let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3OtkA")).then(() => parcelRequire('55Rtn'));